<template>
    <div v-if="!loading && clients" class="w-full">
        <DataTable :value="clients" responsiveLayout="scroll" ref="dt" dataKey="id" lazy
            v-model:filters="lazyParams.filters"
            :rows="lazyParams.rows"
            :totalRecords="totalRecords"
            @page="onPage($event)" @sort="onSort($event)" @filter="onFilter($event)"
            :loading="loading" 
            filterDisplay="menu" 
            :globalFilterFields="globalFields" >

            <Column field="id" header="" filterMatchMode="contains" :showFilterMenu="false" :showFilterMatchModes="false">
                <template #header>
                    <span class="text-xs font-medium">ID</span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter w-12rem" placeholder="Найти" />
                </template>
                <template #body="{ data }">
                    <div class="text-sm flex flex-row" @click="copy(data.id)">
                        <span class="text-xs flex my-auto overflow-hidden" style="max-width:4em">
                            <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                {{ data.id }}
                            </span>
                        </span>...
                        <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                    </div>
                </template>
            </Column>

            <Column field="name">
                <template #header>
                    <span class="text-xs font-medium">Имя</span>
                </template>
                <template #body="{ data }">
                    <span class="text-xs flex">
                        {{ data.first_name }} {{ data.last_name }}
                    </span>
                </template>
            </Column>

            <Column field="name">
                <template #header>
                    <span class="text-xs font-medium">KYC</span>
                </template>
                <template #body="{ data }">
                    <div class="flex flex-row gap-1 align-items-center">
                        <Tag v-if="data.kyc && data.kyc.type" :severity="data.kyc.type" :value="data.kyc.type" class="text-xs white-space-nowrap" />
                        <Tag :severity="getKycSeverity(data)" class="text-xs white-space-nowrap">
                            {{ getKycStatus(data) }}
                        </Tag>
                        <span v-if="data.kyc && data.kyc.doc_id" @click="copy(data.kyc.doc_id)" 
                            class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                        <!-- <div v-if="data.kyc && data.kyc.last_message && data.kyc.status != 'approved'" class="mb-2 text-600">
                            Сообщение: {{ data.kyc.last_message }}
                        </div> -->
                    </div>
                </template>
            </Column>

            <Column field="email" filterMatchMode="contains" :showFilterMenu="true" :showFilterMatchModes="false">
                <template #header>
                    <span class="text-xs font-medium">Email</span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter w-12rem" placeholder="Найти" />
                </template>
                <template #body="{ data }">
                    <span class="text-xs flex">
                        {{ data.email }}
                    </span>
                </template>
            </Column>

            <Column field="phone" filterMatchMode="contains" :showFilterMenu="true" :showFilterMatchModes="false">
                <template #header>
                    <span class="text-xs font-medium">Телефон</span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter w-12rem" placeholder="Найти" />
                </template>
                <template #body="{ data }">
                    <span class="text-xs flex">
                        {{ data.phone }}
                    </span>
                </template>
            </Column>

            <Column field="">
                <template #header>
                    <span class="text-xs font-medium">Действия</span>
                </template>
                <template #body="{ data }">
                    <div class="flex gap-2 flex-row">
                        <EditClient :client="data" @updated="onClientUpdated" />
                        <AddClientDocs :client_id="data.id" :doc_id="data.kyc ? data.kyc.doc_id : null" :hidden="data.kyc && data.kyc.status === 'approved'" />
                    </div>
                </template>
            </Column>

            <Column field="created_at">
                <template #header>
                    <span class="text-xs font-medium">Дата создания</span>
                </template>
                <template #body="{ data }">
                    <span class="text-xs flex">
                        {{ formatDate(data.created_at) }}
                    </span>
                </template>
            </Column>

            <template #footer>
                <span class="text-sm text-600 font-medium">
                    Всего {{ totalRecords }} клиентов 
                </span>
            </template>

        </DataTable>
        <Paginator v-model:first="lazyParams.first" :rows="lazyParams.rows" :totalRecords="totalRecords" 
            template="FirstPageLink  PageLinks LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 20, 30, 50, 100]" 
            @page="onPage"/>
    </div>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import AddClientDocs from '@/components/personal/add_client_docs.vue'
import EditClient from '@/components/personal/edit_client.vue'

export default {
    props: {
        clients: {
            type: Array,
            required: true
        },
        totalRecords: {
            type: Number,
            default: 0
        },
        defaultParams: {
            type: Object,
            default: () => ({})
        },
        filters: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            lazyParams: this.defaultParams,
            sort: {
                field: 'id',
                order: -1
            },

            globalFields: ['id', 'email', 'phone'],
        }
    },
    components: {
        AddClientDocs,
        EditClient,
    },
    methods: {
        getShort(text, length){
            if(text.length <= length) return text
            return '...' + text.substring(text.length - length)
        },
        formatDate(dateStr){
            return this.helper.formatDate(dateStr)
        },
        getKycType(client){
            if(!client || !client.kyc  || !client.kyc.type) return 'Не указан'
            if(client.kyc.type === 'easy_pay'){
                return 'Авангард'
            } else if(client.kyc.type === 'beorg'){
                return 'Беорг'
            } else return client.kyc.type
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        onClientUpdated() {
            this.$emit('updated')
        },
        onPage(event) {
            this.lazyParams.first = event.first
            this.lazyParams.rows = event.rows
            this.lazyParams.page = event.page
            this.lazyParams.pageCount = event.pageCount
            this.$emit('lazyParams', this.lazyParams)
        },
        onSort(event) {
            if(event.sortField && event.sortOrder){
                this.sort = {
                    field: event.sortField,
                    order: event.sortOrder
                }
            } else {
                this.sort = {
                    field: 'date_created',
                    order: -1
                }
            }
            this.lazyParams.sort = this.sort
            this.$emit('lazyParams', this.lazyParams)
        },
        onFilter(params) {
            this.lazyParams.filters = params.filters
            this.$emit('filter', params.filters)
        },
        onRowSelect() {
            this.selectAll = this.selectedCustomers.length === this.totalRecords
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        getKycStatus(client){
            if(!client || !client.kyc  || !client.kyc.status) return 'Не проверен'
            return this.helper.getKycStatus(client.kyc.status)
        },
        getKycSeverity(client){
            if(!client || !client.kyc  || !client.kyc.status) return 'secondary'
            return this.helper.getKycSeverity(client.kyc.status)
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>